module.exports = __webpack_public_path__ + "static/media/aeronave.a55e2424.png";